import React, { useState } from "react";
import { Badge, Box, Stack, Image, Avatar } from "@chakra-ui/react";
import { useRouter } from "next/router";
import { CloseIcon, ChevronDownIcon } from "@chakra-ui/icons";
import styles from "../../styles/components/homePage.module.css";

function QASection({ data }) {
  const router = useRouter();
  const [dropDownOpen, setdropDownOpen] = useState(false);
  const [curruntDropDownIndex, setcurruntDropDownIndex] = useState([]);
  const dropDescArray = [0, 1, 2, 3, 4];
  return (
    <Box className={styles.QA_CONTAINER}>
      <img
        className={styles.blog__top__rightBgSM}
        src="/new-ui/images/QALeftImage.png"
      />
      <Box className={styles.QA_Heading}>Q & A</Box>
      <Box className={styles.QA_Paragraph}>
      Answers to commonly asked questions from the experts on CoverClap.
      </Box>

      {data?.map((item, index) => {
        return (
          <Box>
            <Box className={styles.rowContainer}>
              <Box className={styles.headingDropdown}>{item?.title}</Box>
              <Box
                className={styles.iconContainer}
                onClick={() => {
                  if (dropDownOpen && curruntDropDownIndex.includes(index)) {
                    const filterData = curruntDropDownIndex.filter(
                      (i) => i !== index
                    );
                    setcurruntDropDownIndex(filterData);
                  } else {
                    setcurruntDropDownIndex([...curruntDropDownIndex, index]);
                    setdropDownOpen(true);
                  }
                }}
              >
                {dropDownOpen && curruntDropDownIndex.includes(index) ? (
                  <CloseIcon color="#000000" />
                ) : (
                  <ChevronDownIcon
                    className={styles.dropwonIcon}
                    boxSize={7}
                    color="#000000"
                  />
                )}
              </Box>
            </Box>

            {dropDownOpen && curruntDropDownIndex.includes(index) && (
              <div className={styles.dropdownDesc} dangerouslySetInnerHTML={{ __html: item?.description }} />
            )}
            <Box className={styles.bottomLine}></Box>
          </Box>
        );
      })}
    </Box>
  );
}

export default QASection;
